import partition from 'lodash/partition';

import { CustomProperty } from '@evidentid/tprm-portal-lib/models/dashboard';

/**
 * Returns customProperties sorted by their position in customPropertiesOrder.
 * Properties not present in the order array are appended at the end, sorted alpha by name.
 */
export function getSortedCustomProperties(
    customProperties: CustomProperty[],
    customPropertiesOrder: string[],
): CustomProperty[] {
    const orderMap = new Map(customPropertiesOrder.map((key, index) => [ key, index ]));

    const [ ordered, unordered ] = partition(customProperties, (p) => orderMap.has(p.key));

    ordered.sort((a, b) => (orderMap.get(a.key) ?? 0) - (orderMap.get(b.key) ?? 0));
    unordered.sort((a, b) => a.name.localeCompare(b.name));

    return [ ...ordered, ...unordered ];
}
